export const setTheme = (payload) => ({
  type: 'SET_THEME',
  payload,
});
